
import { gql } from "apollo-boost";
import { useCallback, useContext } from "react";
import { ApolloContext } from "react-apollo";
import { axiosRequest } from "../client";
import { uri } from '../../../../apollo';

export const useToken = () => {
  const apollo = useContext(ApolloContext);

  const getToken = useCallback(async () => {
    try {
      const token = sessionStorage.getItem('token');

      const result = await apollo.client.mutate({
        mutation: gql`
          mutation refreshToken($token: String!) {
            refreshToken(token: $token) {
              token
            }
          }
        `,
        variables: { token }
      });
      
      return result.data.refreshToken.token;
    } catch (error) {
      throw new Error('Erro ao atualizar token.');
    }
  }, []);

  return { getToken }
}

export const PortalService = {
  verifyBalance: async ({ token }) => {
    const { result } = await axiosRequest('GET', {
      host: uri,
      path: `/zapi/balance/`,
      headers: {
        Authorization: `JWT ${token}`,
      },
      validations: {
        codeSuccess: 200,
        msgError: 'Erro ao consultar dados de notificação.',
      },
    });

    return result;
  },
}


// WEBPACK FOOTER //
// ./src/components/Pages/Wallet/services/portal.js